import { checkEmptyArray, isObject } from "../services";

export const filterLocations = (previousValue, newValue) => {
  const arr = [
    "includeCountryIds",
    "includeCountyIds",
    "includeCityIds",
    "includeSettlementIds"
  ];

  const returnValue = { ...previousValue };

  arr.forEach(el => {
    if (!newValue[el] && previousValue[el]) {
      delete returnValue[el];
    }
  });

  return returnValue;
};


// WEBPACK FOOTER //
// ./src/utils/filterMultiLevelFields.ts